const optionServiceName = "/Option";

export function optionService (http)  {
    return {
        getOptionsAsync: async questionId => {
            let parameters = {
                Id: questionId
            }
            return await http.post(optionServiceName + '/GetOptionsAsync', parameters);
        }
    }
}